<div class="col-6 m-1">
  <ap-table
    class="w-100"
    #basicTable
    [data]="(monitorService.getMonitorStatus | async) || []">
    <table>
      <thead>
        <tr>
          <th>{{ 'monitor.table.component' | translate }}</th>
          <th>{{ 'monitor.table.status' | translate }}</th>
          <th>{{ 'monitor.table.details' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ 'webAppMonitor.data.component' | translate }}</td>
          <td>{{ 'webAppMonitor.data.status' | translate }}</td>
          <td>{{ 'webAppMonitor.data.details' | translate }}</td>
        </tr>
        @for (item of basicTable.data; track item.component) {
          <tr>
            <td>{{ item.component }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.details }}</td>
          </tr>
        }
      </tbody>
    </table>
  </ap-table>
</div>
